import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useState} from "react";
import "../../style/datePicker.css"
import FileInput from "../system/fileInput";
import {submitServiceActivity} from "../../services/service/service_activity";
import {ServiceContext} from "../../context/service";
import {Toaster} from "../../helper/Toaster";

export function AgentServiceActionForm() {

  const {service, modalOpen, setModalOpen, setLastDataRefresh, setStep} = useContext(ServiceContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  const [metaText, setMetaText] = useState("");
  const [description, setDescription] = useState("")
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);


  const save = async () => {
    if (loading) return; // Prevent multiple simultaneous requests
    
    const data = {
      service_id: service.id,
      type: "action",
      meta_text: metaText,
      description: description,
      file: file,
    };

    try {
      setLoading(true);
      let result = await submitServiceActivity(data);

      if (result.status === 201 || result.status === 202) {
        setLastDataRefresh(Date.now())
        setStep("check")
      } else {
        Toaster.failure(null, <Typography variant="small">
          {result.data?.message || 'خطا در ثبت عملیات'}
        </Typography>);
      }
    } catch (err) {
      Toaster.failure(null, <Typography variant="small">
        {err.message || 'خطا در ثبت عملیات'}
      </Typography>);
      console.error('Service action error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ثبت عملیات جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <Input variant="standard"
                   value={metaText}
                   label={Dict('title')}
                   onChange={(e) => {
                     setMetaText(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Textarea variant="standard"
                      value={description}
                      label={Dict('description')}
                      onChange={(e) => {
                        setDescription(e.target.value)
                      }}
            />
          </div>

          <div className="flex flex-col w-full mb-4">
            <FileInput
              label={Dict('file')}
              fileCode={file}
              onChange={(e) => {
                setFile(e.target.files[0]);
              }}/>
            {/*<Validator state={file} rules="required"/>*/}
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">

          <Button variant="gradient" color="gray" onClick={save} className="ml-1" disabled={loading}>
            {loading ? 'در حال ذخیره...' : 'ذخیره'}
          </Button>
          <Button variant="text" color="gray" onClick={() => {
            // handleOpen();
            setStep("check")
          }}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}